"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingMatrix = exports.SCHEDULING_MATRIX_SELECT_MOD = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const defaultIsSelected_1 = require("./defaultIsSelected");
const helpers_2 = require("./helpers");
const Tile_1 = require("./Tile");
const timeHeader_1 = require("./timeHeader");
const TopLegend_1 = require("./TopLegend");
const types_1 = require("./types");
const useWillSelect_1 = require("./useWillSelect");
var SCHEDULING_MATRIX_SELECT_MOD;
(function (SCHEDULING_MATRIX_SELECT_MOD) {
    SCHEDULING_MATRIX_SELECT_MOD["select"] = "select";
    SCHEDULING_MATRIX_SELECT_MOD["unselect"] = "unselect";
    SCHEDULING_MATRIX_SELECT_MOD["auto"] = "auto";
})(SCHEDULING_MATRIX_SELECT_MOD = exports.SCHEDULING_MATRIX_SELECT_MOD || (exports.SCHEDULING_MATRIX_SELECT_MOD = {}));
const Row = (0, styled_components_1.default)(StackView_1.StackView) `
    height: ${helpers_1.SIZE_L};
`;
const RowHeader = (0, styled_components_1.default)(Row) `
    height: ${helpers_1.SIZE_XL};
`;
const FooterContentRow = (0, styled_components_1.default)(Row) `
    padding-top: ${32 - 4}px;
`;
const TileArea = (0, styled_components_1.default)(View_1.View) ``;
const MatrixTiles = styled_components_1.default.div ``;
const TopSelection = (0, styled_components_1.default)(View_1.View) `
    position: absolute;
    top: 0;
    left: 4px;
    right: 4px;
    bottom: 0;
    background-color: ${({ theme }) => theme.colorHighlightLight};
`;
const LeftSelection = (0, styled_components_1.default)(View_1.View) `
    position: absolute;
    top: 0;
    left: -8px;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.colorHighlightLight};
`;
const Root = styled_components_1.default.div `
    display: grid;
    grid-template-columns: repeat(3, max-content);
    gap: 0 ${helpers_1.SPACING_XS};
    grid-template-areas:
        '. legend .'
        'title content description'
        'controlsTitle controls controls';
    user-select: none;
    padding-top: ${({ hasLegendHeader }) => hasLegendHeader ? `${24 + 4 + 16 + 8}px` : `${24 + 4}px`};
`;
const StyledSchedulingMatrixTitleColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    grid-area: title;
`;
const StyledSchedulingMatrixControlsTitleColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    grid-area: controlsTitle;
`;
const StyledSchedulingMatrixContentColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    grid-area: content;
`;
const StyledSchedulingMatrixDescriptionColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    grid-area: description;
`;
const StyledSchedulingMatrixControlsColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    grid-area: controls;

    ${FooterContentRow} {
        flex-grow: 1;
    }
`;
const StyledSchedulingMatrixLegendColumn = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    grid-area: legend;
`;
const SchedulingMatrixBase = (0, helpers_1.createUIElement)('SchedulingMatrix', function (_a, ref) {
    var { className, rows, columns, data, mode, onSelect, footer, tileSize = types_1.SCHEDULING_MATRIX_TILE_SIZE.m, isSelected = defaultIsSelected_1.defaultIsSelected, isDisabled, legendHeader, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "rows", "columns", "data", "mode", "onSelect", "footer", "tileSize", "isSelected", "isDisabled", "legendHeader", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const [startSelectValue, setStartSelectValue] = (0, react_1.useState)(null);
    const [hoverValue, setHoverValue] = (0, react_1.useState)(null);
    const { setWillSelect, removeWillSelect, removeAllWillSelect, isSomeInRowWillSelect, isSomeInColumnWillSelect, isWillSelected, getAllWillSelected } = (0, useWillSelect_1.useWillSelect)();
    const isAutoMode = mode === SCHEDULING_MATRIX_SELECT_MOD.auto;
    const modeState = (0, helpers_1.useStateValue)(mode === SCHEDULING_MATRIX_SELECT_MOD.auto ? SCHEDULING_MATRIX_SELECT_MOD.select : mode, [mode]);
    const startSelect = (rowIndex, columnIndex) => {
        setStartSelectValue({ rowIndex, columnIndex });
    };
    const endSelect = () => {
        setStartSelectValue(null);
        removeAllWillSelect();
    };
    const clickRowHeaderHandler = (rowIndex) => {
        const nextSelectedValue = isAutoMode
            ? !(0, helpers_2.isAllRowSelected)({
                rowIndex,
                isSelected,
                columns,
                rows,
                data
            })
            : modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect((0, helpers_2.getRowCellsSelected)({
            rowIndex,
            columns,
            rows
        }), nextSelectedValue);
    };
    const clickColumnHeaderHandler = (columnIndex) => {
        const nextSelectedValue = isAutoMode
            ? !(0, helpers_2.isAllColumnSelected)({
                columnIndex,
                isSelected,
                columns,
                rows,
                data
            })
            : modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect((0, helpers_2.getColumnCellsSelected)({
            columnIndex,
            columns,
            rows
        }), nextSelectedValue);
    };
    const clickTileAreaHandler = ({ disabled, rowIndex, columnIndex, rowKey, columnKey }) => {
        if (disabled) {
            return;
        }
        const nextSelectedValue = modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
        onSelect === null || onSelect === void 0 ? void 0 : onSelect([
            {
                rowIndex,
                columnIndex,
                rowKey,
                columnKey
            }
        ], nextSelectedValue);
        if (isAutoMode) {
            modeState.setValue(nextSelectedValue
                ? SCHEDULING_MATRIX_SELECT_MOD.unselect
                : SCHEDULING_MATRIX_SELECT_MOD.select);
        }
    };
    const mouseDownTileAreaHandler = ({ disabled, rowIndex, columnIndex }) => {
        if (disabled) {
            return;
        }
        startSelect(rowIndex, columnIndex);
    };
    const mouseEnterTileAreaHandler = ({ rowIndex, columnIndex, rowKey, columnKey }) => {
        setWillSelect({ rowIndex, columnIndex }, startSelectValue);
        const selected = isSelected({
            rowIndex,
            columnIndex,
            data,
            rowKey,
            columnKey
        });
        setHoverValue({ rowIndex, columnIndex });
        if (!startSelectValue && isAutoMode) {
            modeState.setValue(selected
                ? SCHEDULING_MATRIX_SELECT_MOD.unselect
                : SCHEDULING_MATRIX_SELECT_MOD.select);
        }
    };
    const mouseLeaveTileAreaHandler = ({ rowIndex, columnIndex }) => {
        if (startSelectValue) {
            return;
        }
        removeWillSelect({ rowIndex, columnIndex });
    };
    const mouseLeaveMatrixTiles = () => {
        setHoverValue(null);
    };
    const isSelectedRowHeader = (rowIndex) => {
        return (hoverValue === null || hoverValue === void 0 ? void 0 : hoverValue.rowIndex) === rowIndex || isSomeInRowWillSelect(rowIndex);
    };
    const isSelectedColumnHeader = (columnIndex) => {
        return (hoverValue === null || hoverValue === void 0 ? void 0 : hoverValue.columnIndex) === columnIndex || isSomeInColumnWillSelect(columnIndex);
    };
    const hasLegendHeader = !!legendHeader;
    const sunIconPosition = (0, helpers_2.getSunIconPosition)({
        rowIndexForSunIcon: legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.rowIndexForSunIcon,
        columns
    });
    const rowIndexForSunIcon = sunIconPosition === helpers_2.SUN_ICON_POSITION.lastColumn
        ? columns.length - 1
        : legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.rowIndexForSunIcon;
    (0, react_1.useEffect)(() => {
        const cb = () => {
            const items = getAllWillSelected()
                .map(({ columnIndex, rowIndex }) => {
                const disabled = isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled({
                    rowIndex,
                    columnIndex,
                    data,
                    rowKey: rows[rowIndex].key,
                    columnKey: columns[columnIndex].key
                });
                if (disabled) {
                    return null;
                }
                return {
                    rowIndex,
                    columnIndex,
                    rowKey: rows[rowIndex].key,
                    columnKey: columns[columnIndex].key
                };
            })
                .filter(Boolean);
            const nextSelectedValue = modeState.getValue() === SCHEDULING_MATRIX_SELECT_MOD.select;
            if (items.length > 1) {
                onSelect === null || onSelect === void 0 ? void 0 : onSelect(items, nextSelectedValue);
            }
            endSelect();
        };
        document.addEventListener('mouseup', cb, { capture: true });
        return () => {
            document.removeEventListener('mouseup', cb, { capture: true });
        };
    }, [columns, data, endSelect, getAllWillSelected, isDisabled, modeState, onSelect, rows]);
    return (react_1.default.createElement(Root, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": rest['data-selector-id'], hasLegendHeader: hasLegendHeader, direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.xs, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-SchedulingMatrix', className) }),
        react_1.default.createElement(StyledSchedulingMatrixTitleColumn, { direction: StackView_1.STACK_DIRECTION.column }, rows.map((row, rowIndex) => (react_1.default.createElement(RowHeader, { key: rowIndex, direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, root: true, spaceVertical: View_1.INDENT.xs, onClick: () => clickRowHeaderHandler(rowIndex) },
            react_1.default.createElement(View_1.View, { spaceFill: View_1.SPACE_FILL.all, align: View_1.VIEW_ALIGN.center, spaceRight: View_1.INDENT.xl, root: true },
                isSelectedRowHeader(rowIndex) && react_1.default.createElement(LeftSelection, null),
                react_1.default.createElement(Text_1.Text, null, row.title)))))),
        react_1.default.createElement(StyledSchedulingMatrixContentColumn, { direction: StackView_1.STACK_DIRECTION.column, root: true },
            react_1.default.createElement(MatrixTiles, { onMouseLeave: mouseLeaveMatrixTiles }, rows.map((row, rowIndex) => (react_1.default.createElement(StackView_1.StackView, { key: rowIndex, direction: StackView_1.STACK_DIRECTION.row }, columns.map((col, columnIndex) => {
                const selected = isSelected({
                    rowIndex,
                    columnIndex,
                    data,
                    rowKey: row.key,
                    columnKey: col.key
                });
                const disabled = isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled({
                    rowIndex,
                    columnIndex,
                    data,
                    rowKey: row.key,
                    columnKey: col.key
                });
                return (react_1.default.createElement(TileArea, { key: columnIndex, spaceHorizontal: helpers_2.SPACE_HORIZONTAL_TILE, spaceVertical: helpers_2.SPACE_VERTICAL_TILE, onMouseDown: () => {
                        mouseDownTileAreaHandler({
                            disabled,
                            rowIndex,
                            columnIndex
                        });
                    }, onMouseEnter: () => {
                        mouseEnterTileAreaHandler({
                            rowIndex,
                            columnIndex,
                            rowKey: row.key,
                            columnKey: col.key
                        });
                    }, onMouseLeave: () => {
                        mouseLeaveTileAreaHandler({
                            rowIndex,
                            columnIndex
                        });
                    }, onClick: () => clickTileAreaHandler({
                        disabled,
                        rowIndex,
                        columnIndex,
                        rowKey: row.key,
                        columnKey: col.key
                    }) },
                    react_1.default.createElement(Tile_1.Tile, { size: tileSize, key: columnIndex, willSelect: isWillSelected({
                            rowIndex,
                            columnIndex
                        }), selected: selected, disabled: disabled })));
            })))))),
        react_1.default.createElement(StyledSchedulingMatrixDescriptionColumn, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, spaceTop: View_1.INDENT.xs }, rows.map((row, rowIndex) => (react_1.default.createElement(Row, { key: rowIndex, direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.s, view: Text_1.TEXT_VIEW.secondary }, typeof row.description === 'function'
                ? row.description({ data, rowIndex, rowKey: row.key })
                : row.description))))),
        footer && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledSchedulingMatrixControlsTitleColumn, { direction: StackView_1.STACK_DIRECTION.column },
                react_1.default.createElement(Row, { key: 'footer', direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, indentTop: View_1.INDENT.xs, spaceTop: View_1.INDENT.l },
                    react_1.default.createElement(Text_1.Text, null, footer.title))),
            react_1.default.createElement(StyledSchedulingMatrixControlsColumn, null, footer && (react_1.default.createElement(FooterContentRow, { key: 'footer', direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, spaceLeft: View_1.INDENT.xs }, footer.render()))))),
        react_1.default.createElement(StyledSchedulingMatrixLegendColumn, null,
            react_1.default.createElement(TopLegend_1.TopLegend, { tileSize: tileSize, align: StackView_1.STACK_ALIGN.fill, spaceLeft: View_1.INDENT.xs }, columns.map((col, columnIndex) => (react_1.default.createElement(TopLegend_1.ColumnHeader, { key: columnIndex, direction: StackView_1.STACK_DIRECTION.row, distribution: StackView_1.STACK_DISTRIBUTION.center }, isSelectedColumnHeader(columnIndex) && react_1.default.createElement(TopSelection, null))))),
            react_1.default.createElement(TopLegend_1.TopLegend, { tileSize: tileSize, spaceLeft: View_1.INDENT.xs }, columns.map((col, columnIndex) => (react_1.default.createElement(TopLegend_1.ColumnHeader, { key: columnIndex, direction: StackView_1.STACK_DIRECTION.row, distribution: StackView_1.STACK_DISTRIBUTION.center, align: StackView_1.STACK_ALIGN.center, onClick: () => clickColumnHeaderHandler(columnIndex) }, col.renderCel ? col.renderCel() : react_1.default.createElement(Text_1.Text, null, col.title || ''))))),
            hasLegendHeader && (react_1.default.createElement(TopLegend_1.TopLegendHeader, { sideOffset: (legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.sideOffset) || 0, rowIndexForSunIcon: rowIndexForSunIcon, sunIconPosition: sunIconPosition, sunIconSize: tileSize }, legendHeader === null || legendHeader === void 0 ? void 0 : legendHeader.render())))));
});
SchedulingMatrixBase.modes = SCHEDULING_MATRIX_SELECT_MOD;
SchedulingMatrixBase.tileSizes = types_1.SCHEDULING_MATRIX_TILE_SIZE;
SchedulingMatrixBase.columnPresets = {
    timeRange: timeHeader_1.SCHEDULING_MATRIX_COLUMN_TIME_PRESET
};
exports.SchedulingMatrix = SchedulingMatrixBase;
//# sourceMappingURL=SchedulingMatrix.js.map